import { Controller } from '@hotwired/stimulus';

// Live scoring for the AML risk assessment form: mirrors the spreadsheet auto-sum.
export default class extends Controller {
  static targets = ['total', 'level'];

  connect() {
    this.recompute();
  }

  recompute() {
    const pointsByQuestion = new Map();
    this.element.querySelectorAll('input[type=radio]:checked').forEach((input) => {
      pointsByQuestion.set(input.name, Number(input.dataset.points || 0));
    });

    const total = [...pointsByQuestion.values()].reduce((sum, points) => sum + points, 0);
    this.totalTarget.textContent = String(total);
    this.levelTarget.textContent = this.levelFor(total);
  }

  levelFor(total) {
    if (total <= 4) return 'Niski';
    if (total <= 8) return 'Średni';
    return 'Wysoki';
  }
}
